<template>
    <div class="bg re_sizing" v-if="showBg">
        <div class="content re_text_c re_sizing">
            <div class="user-info">
                <img :src="info.photo" alt="头像" class="avatar">

                <div class="nickname re_ellipsis">您的好友&nbsp;{{ info.nickName }}</div>
            </div>
            <!-- Phone input -->
            <div class="re_width100 re_margin_top_16">
                <input type="number" v-model="phone" class="input re_sizing" maxlength="11" placeholder="请输入手机号">
            </div>

            <!-- SMS code input -->
            <div class="re_width100 sms-group re_relative">
                <input type="text" v-model="smsCode" class="input re_sizing" maxlength="6" placeholder="输入验证码">
                <button :class="['sms-button', { 'disabled': counting }]" @click="getSmsCode" :disabled="counting">
                    {{ countText }}
                </button>
            </div>

            <!-- Submit button -->
            <button class="submit-button" @click="handleSubmit">注册/登录开水壶，立即抢红包</button>

            <!-- Agreement checkbox -->
            <div class="agreement">
                <img v-if="agreed" @click="agreed = !agreed" class="agree-icon" src="../../../assets/register/checked.png" alt="同意">
                <img v-else @click="agreed = !agreed" class="agree-icon" src="../../../assets/register/check.png" alt="同意">
                <label for="agree">
                    <span>阅读并同意</span>
                    <a href="https://www.kaishuihu.com/kshptyhxy.html" target="_blank">《用户服务协议》</a>
                    <span>和</span>
                    <a href="https://www.kaishuihu.com/kshysqzc.html" target="_blank">《隐私政策》</a>
                </label>
            </div>
        </div>
        <van-overlay :show="show" :lock-scroll="false">
            <div class="coupon-new">
                <div class="title">
                    <div>送您{{deductionMoney}}元红包</div>
                    <div>登录后即可领取</div>
                </div>
				<div class="newCoupopContent">
                    <div class="new-item" v-for="(item,index) in coupopList" :key="index">
                        <div class="new-item-left">
                            <div>
                                ￥
                                <text>{{item.deductionMoney}}</text>
                            </div>
                            <div>{{item.isThreshold == 0 ? '无门槛' : '满'+item.useMinMoney+'元可用'}}</div>
                        </div>
                        <div class="new-item-right">
                            <div class="hidden">{{item.couponRangeLabel}}</div>
                            <div>
                                <div class="hidden">限店铺“{{item.shopName}}”使用</div>
                            </div>
                        </div>
                    </div>
				</div>
                <div class="coupopBtn" @click="downLoad">下载APP领取福利</div>
				<img
					class="close"
					@click="show = false"
					src="../../../assets/appleTree/apple_tree_set_xxx.png"
					mode=""
				/>
			</div>
        </van-overlay>
    </div>
    <div v-else class="nodata">
        <div class="nodata-img">
            <img src=".../../../assets/register/scan.png" alt="">
        </div>
        请使用微信扫描二维码
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
// import { userInviteShareWxInfo, getInfo } from './api.js'
import { ref, onMounted, computed } from 'vue';
import { showToast, showConfirmDialog, showLoadingToast, closeToast } from 'vant';
import { sendRegisterSmsCode, codeRegister, shareConfig, briefInfo } from './api.js'
const router = useRouter()
const route = useRoute()

const phone = ref('')
const smsCode = ref('')
const agreed = ref(false)
const counting = ref(false)
const counter = ref(60)
const env = ref('')

const showBg = ref(true)

onMounted(() => {
    console.log(process.env.NODE_ENV)
    if(process.env.NODE_ENV == 'development'){
        env.value = 'dev'
    }else if(process.env.NODE_ENV == 'test'){
        env.value = 'test'
    }else if(process.env.NODE_ENV == 'staging'){
        env.value = 'gray'
    }else if(process.env.NODE_ENV == 'production'){
        env.value = 'prod'
    } else {
        env.value = 'dev'
    }
    // if (route.query && route.query.isShare) {
    //     showBg.value = route.query.isShare == 1 ? true : false
    // }
    getInfo()
})
const info = ref({})
const getInfo = async () => {
    briefInfo().then(res => {
        info.value = res.data
        shareGetConfig()
    })
}


// 倒计时文本
const countText = computed(() => {
    return counting.value ? `${counter.value}秒后重新发送` : '获取验证码'
})

// 验证手机号
const validatePhone = () => {
    if (!phone.value) {
        showToast('请输入注册手机号')
        return false
    }
    if (!/^1[3456789]\d{9}$/.test(phone.value)) {
        showToast('手机号码有误')
        return false
    }
    return true
}

// 获取验证码
const getSmsCode = async () => {
    if (!validatePhone()) return

    counting.value = true
    try {
        const res = await sendRegisterSmsCode({ phone: phone.value, type: 5, device: 'h5' })
        if (res.code == 1) {
            startCountdown()
            showToast('验证码发送成功')
        } else {
            counting.value = false
            showToast(res.msg)
        }
    } catch (error) {
        counting.value = false
        showToast('获取验证码失败，请稍后重试')
    }
}

// 倒计时
const startCountdown = () => {
    counter.value = 60
    const timer = setInterval(() => {
        counter.value--
        if (counter.value <= 0) {
            counting.value = false
            clearInterval(timer)
        }
    }, 1000)
}
const shareGetConfig = async () => {
    shareConfig({ url: location.href }).then(res => {
        console.log(res)
        if (res.code == 1) {
            wx.config({
                debug: false,
                appId: res.appid,
                timestamp: res.timestamp,
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
            })
            wx.ready(function () {
                wx.updateAppMessageShareData({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                    link: data.url,
                    imgUrl: data.imgUrl, // 分享图标
                    success: () => {
                        // doShareDone()
                    },
                    cancel: () => {
                        // doShareCancel()
                    }
                });
                wx.updateTimelineShareData({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                    link: data.url,
                    imgUrl: data.imgUrl, // 分享图标
                    success: () => {
                        // doShareDone()
                    },
                    cancel: () => {
                        // doShareCancel()
                    }
                });
            });
        }
    })
}
function downLoad() {
    show.value = false
    if (env.value == 'prod') {
        window.location.href = "http://www.kaishuihu.com/download/download.html?inviteCode=" + route.query.inviteCode + "&channelCode=" + route.query.inviteCode + "&type=register";
    } else {
        window.location.href = "https://demo.lanlingcb.com/download/download1.html?inviteCode=" + route.query.inviteCode + "&channelCode=" + route.query.inviteCode + "&type=register";
    }
}

const coupopList = ref([])
const deductionMoney =ref('')
const show = ref(false)

function downFn() {
    showConfirmDialog({
        title: '去下载APP',
    }).then(res => {
        if (res === 'confirm') {
            if (env.value == 'prod') {
                window.location.href = "http://www.kaishuihu.com/download/download.html?inviteCode=" + route.query.inviteCode + "&channelCode=" + route.query.inviteCode + "&type=register";
            } else {
                window.location.href = "https://demo.lanlingcb.com/download/download1.html?inviteCode=" + route.query.inviteCode + "&channelCode=" + route.query.inviteCode + "&type=register";
            }
        }
    })
}
// 提交表单
const handleSubmit = async () => {
    if (!validatePhone()) return

    if (!smsCode.value) {
        showToast('请填写验证码')
        return
    }
    if (smsCode.value.toString().length !== 6) {
        showToast('验证码填写错误')
        return
    }

    if (!agreed.value) {
        showToast('请阅读协议并勾选')
        return
    }
    console.log(env.value,'env.value')
    showLoadingToast()
    try {
        const res = await codeRegister({ phone: phone.value, smsCode: smsCode.value, env: env.value, device: 'h5', sourceType: 'ksh_h5_register', version: '2.4.2', notAddFriend: '1' })
        if (res.code == 1) {
            try {
                if (res.data.dpShopCouponListDTOS.length > 0) {
                    show.value = true
                    coupopList.value = res.data.dpShopCouponListDTOS
                    deductionMoney.value = res.data.deductionMoney
                } else {
                    downFn() 
                }
            } catch (error) {
                downFn() 
            }
        } else {
            showToast(res.msg)
        }
    } catch (error) {
        showToast('注册失败，请稍后重试')
    } finally {
        closeToast()
    }
}
</script>

<style lang="less" scoped>
.nodata {
    width: 100%;
    height: calc(100vh - 13.75rem);
    background: #fff;
    text-align: center;
    padding-top: 13.75rem;
    font-weight: 500;
    font-size: 1rem;
    color: #1D1D2C;

    .nodata-img {
        width: 6.25rem;
        height: 6.25rem;
        margin: 0 auto;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.bg {
    width: 100%;
    min-height: 50.6875rem;
    background: #fff url('../../../assets/register/registerBg.png') left top / 100% 50.6875rem no-repeat;
    overflow: auto;
    padding-top: 15.75rem;
}

.avatar {
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 50%;
    border: 0.125rem solid #fff;
    object-fit: cover;
}

.nickname {
    max-width: 90%;
    margin: 1.125rem auto 0;
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.25rem;
    color: #1D1D2C;
}

.content {
    width: calc(100% - 2rem);
    min-height: 17.75rem;
    margin: 0 auto;
    padding: 2.0625rem 1.25rem 1.25rem;
    background: #fff;
    border-radius: 1.875rem;
    // box-shadow: 0 0.625rem 1.875rem #6841bd14;
}

.user-info {
    margin-bottom: 1.5625rem;
}

.input {
    width: 100%;
    height: 2.5rem;
    border-radius: 1.25rem;
    padding: 0 1rem;
    border: none;
    margin: 0 auto;
    background: #F5F8FC;
    color: #1D1D2C;
    font-size: 0.875rem;
}

.input::placeholder {
    color: #C3CAD6;
}

.re_margin_top_16 {
    margin-top: 0;
}

.re_width100 {
    width: 100%;
}

.re_width100::before {
    display: block;
    margin: 0 0 0.5rem;
    text-align: left;
    font-size: 0.8125rem;
    line-height: 1.125rem;
    color: #4C5360;
}

.re_margin_top_16::before {
    content: "手机号";
}

.sms-group {
    margin: 1.5rem 0 2rem;
}

.sms-group::before {
    content: "验证码";
}

.sms-button {
    position: absolute;
    right: 0.625rem;
    top: 2.125rem;
    min-width: 5.25rem;
    height: 1.5rem;
    background: transparent;
    color: #8D4DFF;
    border: none;
    border-left: 0.0625rem solid #E5EAF2;
    font-size: 0.875rem;
    line-height: 1.5rem;
    padding: 0 0 0 0.75rem;
}

.sms-button.disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.submit-button {
    width: 100%;
    height: 3rem;
    background-image: linear-gradient(92deg, #5C64FF 0%, #C347FF 100%);
    border-radius: 1.5rem;
    border: none;
    margin: 0 auto;
    box-shadow: 0 0.375rem 0.75rem #914cff3d;
    font-size: 1rem;
    color: #fff;
    font-weight: 600;
    line-height: 3rem;
}

.agreement {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.875rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #AFB6C3;

    img {
        width: 0.875rem;
        height: 0.875rem;
        margin-right: 0.375rem;
    }
}

.agreement a {
    text-decoration: none;
    color: #8D4DFF;
}
</style>
<style lang="less" scoped>
    .hidden {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
	.coupon-new {
		position: fixed;
		background: #fff;
		width: 17.6875rem;
		height: 22.75rem;
		margin: 0 auto;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
        border-radius: 1.875rem;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4.5rem;
            opacity: 0.4;
            background-image: linear-gradient(180deg, #ffffff00 0%, #ffffffbf 63%, #FFFFFF 100%), linear-gradient(94deg, #B04AFD 15%, #6E69D1 86%);
            border: 0.0625rem solid #FFFFFF;
            border-radius: 1.875rem 1.875rem 0 0;
            box-sizing: border-box;
            pointer-events: none;
        }

        .title {
            position: relative;
            z-index: 1;
            text-align: center;
            >div:nth-child(1) {
                line-height: 1.75rem;
                font-size: 1.25rem;
                margin-top: 0.875rem;
                color: #1D1D2C;
            }
            >div:nth-child(2) {
                margin-top: 0.5rem;
                font-weight: 700;
                font-size: 1rem;
                line-height: 1rem;
                color: #787987;
            }
        }
        .coupopBtn {
            position: relative;
            z-index: 1;
            width: 13.375rem;
            height: 3.375rem;
            background-image: linear-gradient(120deg, #5E56FD 11%, #B04AFD 100%);
            box-shadow: 0 0.375rem 1rem 0 #7d4afd4f;
            border-radius: 1.6875rem;
            text-align: center;
            margin: 1rem auto 0;
            font-weight: 600;
            font-size: 0.875rem;
            line-height: 3.375rem;
            color: #fff;
        }
		.newCoupopContent {
            position: relative;
            z-index: 1;
			margin-top: 0.6875rem;
            height: 12.5rem;
            overflow-y: scroll;
			.new-item {
				background: url(https://tp.kaishuihu.com/businessunion/wx_sjlm_xiaochengxu/static/coupon/indexCoupop.png) no-repeat;
				background-size: 100% 100%;
				width: 15.6875rem;
				height: 5rem;
				margin: 0 auto 0.5rem;
				display: flex;
				.new-item-left {
					display: flex;
					flex-direction: column;
					justify-content: center;
					text-align: center;
					width: 5.625rem;
                    >div:nth-child(1) {
                            color: #ff4951;
                            font-size: 1rem;
                            font-weight: 700;
                            text {
                                font-size: 1.75rem;
                            }
                    }
					>div:nth-child(2) {
						font-weight: 400;
						font-size: 0.625rem;
						color: #FF8086;
					}
				}
				.new-item-right {
					width: calc(100% - 7.875rem);
					text-align: left;
					display: flex;
					flex-direction: column;
					justify-content: center;
					padding-left: 1.125rem;
					>div:nth-child(1) {
						font-weight: 700;
						font-size: 0.875rem;
						color: #1D1D2C;
						margin-bottom: 0.4375rem;
						
					}
					>div:nth-child(2) {
						font-weight: 400;
						font-size: 0.625rem;
						color: #A2A4AE;
						display: flex;
						align-items: flex-end;
					}
				}
			}
		}
		.close {
			width: 1rem;
			height: 1rem;
			position: absolute;
			right: calc(50% - 0.5rem);
			bottom: -2.5rem;
		}
	}
</style>
